import React from 'react';
import routes from '../../../controller/Routes';
import { isCandidateLoggedIn } from '../../../controller/localStroageHandler';
import { Navigate } from 'react-router-dom';
const CandidatePrivateRoute = ({ children }) => {
  return isCandidateLoggedIn() ? (
    children
  ) : (
    <Navigate to={routes.test.validurl} />
  );
};

export default CandidatePrivateRoute;
